import axios from 'axios';

const api = axios.create({
  // baseURL: 'http://localhost:3333/',
  // baseURL: 'https://162.214.160.241:3317',
  baseURL: 'https://dashboard.mindconsulting.com.br/api/',
});

export default api;
